let swiper;

function learnMoreSlider() {
  if (swiper) {
    swiper.destroy(true, true);
  }
  
  const learnMorePopup = document.querySelector('[data-learnmore-popup]');

  const learnMoreButtons = document.querySelectorAll('button.product__learn-more');

  learnMoreButtons.forEach(button => {
    button.addEventListener('click', () => {
      const slides = learnMorePopup.querySelectorAll('[data-learnmore-item]');
      const swiperButtons = learnMorePopup.querySelectorAll('[data-learnmore-next], [data-learnmore-prev]');

      if (slides.length <= 1) {
        swiperButtons.forEach(button => {
          button.classList.add('swiper-button-lock');
        })
      } else {
        swiperButtons.forEach(button => {
          button.classList.remove('swiper-button-lock');
        })
      }
    })
  })

  if (!learnMorePopup.style.display || learnMorePopup.style.display === 'none') {
    learnMorePopup.style.display = 'block';
  }

  swiper = new Swiper('[data-learnmore-popup]', {
    slidesPerView: 1,
    width: 333,
    spaceBetween: 12,
    centeredSlides: true,
    touchRatio: 1,
    touchAngle: 45,
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      767: {
        slidesPerView: 'auto',
        width: '80%',
        spaceBetween: 79,
        slidesOffsetBefore: window.innerWidth * 0.43,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    },
    on: {
      init: function() {
        if (learnMorePopup.style.display !== 'block') {
          learnMorePopup.style.display = 'block';
        }
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', () =>{
  learnMoreSlider();
})

const optionSelectButton = document.querySelectorAll('[data-option-select-button]');
const optionAdonSelectButton = document.querySelectorAll('[data-option-adon-select-button]');
const mainCategories = document.querySelectorAll('[data-category-name]');
const mainCheckboxes = document.querySelectorAll('[data-main-checkbox]');

function toggleButtons(buttons) {
  buttons.forEach((button) => {
    const learnMoreItemCategory = button
      .closest('[data-learnmore-item]')
      .getAttribute('data-learnmore-item-category');

    button.addEventListener('click', () => {
      mainCategories.forEach((mainCategory) => {
        if (mainCategory.getAttribute('data-category-name') === learnMoreItemCategory) {
          const mainCheckbox = mainCategory.querySelector('[data-main-checkbox]');
          if (!mainCheckbox.checked) {
            mainCheckbox.click();
            const childOptionId = button.getAttribute('data-child-option-id');
            const matchingChildProduct = mainCategory.querySelector(`[data-child-product-id="${childOptionId}"]`);
            if (matchingChildProduct) {
              const matchingChildProductRadio = matchingChildProduct.querySelector('input[type="radio"]');
              matchingChildProductRadio.click();
            }
          }
        }
      });
    });
  });
}

mainCheckboxes.forEach((mainCheckbox) => {
  mainCheckbox.addEventListener('change', () => {
    toggleButtons(optionAdonSelectButton);
    toggleButtons(optionSelectButton);
  });
});

document.querySelectorAll('[data-product-learn-more]').forEach((learnMoreButton) => {
  const learnMorePopup = document.querySelector('[data-learnmore-popup]');
  const learnMoreItems = learnMorePopup.querySelectorAll('[data-learnmore-item-category]');
  learnMoreButton.addEventListener('click', function () {
    const productPickerItem = this.closest('[data-product-picker-item]');
    const categoryName = productPickerItem.getAttribute('data-category-name');
    const overlay = document.querySelector('[data-overlay-popup]');
    document.body.style.overflow = 'hidden';
    overlay.style.display = 'flex';
    learnMorePopup.style.display = 'block';
    var allItems = document.querySelector('[data-learnmore-popup] [data-swiper-wrapper]');
    allItems.innerHTML = '';
    learnMoreItems.forEach((item, index) => {
      const itemCategory = item.getAttribute('data-learnmore-item-category');
      if (itemCategory === categoryName) {
        item.style.display = 'block';
        allItems.appendChild(item);
      } else {
        item.style.display = 'none';
        item.classList.remove('swiper-slide-active');
      }
      learnMoreSlider();
    });
  });
});

function closeLearnMorePopup() {
  const learnMorePopup = document.querySelector('[data-learnmore-popup]');
  const overlayClose = document.querySelector('[data-overlay-popup]');
  overlayClose.style.display = 'none';
  document.body.style.overflow = 'auto';
  if (learnMorePopup) {
    learnMorePopup.style.display = 'none';
  }
}

document.querySelectorAll('[data-option-select-button]').forEach((button) => {
  button.addEventListener('click', function () {
    const childOptionId = this.getAttribute('data-child-option-id');
    const learnMoreItem = this.closest('[data-learnmore-item]');
    const learnMoreCategory = learnMoreItem.getAttribute('data-learnmore-item-category');
    document.body.style.overflow = 'auto';
    document.querySelectorAll('[data-category-name]').forEach((categoryElement) => {
      if (categoryElement.getAttribute('data-category-name') === learnMoreCategory) {
        const childProductElements = categoryElement.querySelectorAll('[data-child-product-id]');
        childProductElements.forEach((childProduct) => {
          childProduct.classList.remove('product__picker-product--active');
          const childProductRadio = childProduct.querySelector('input[type="radio"]');
          if (childProductRadio) {
            childProductRadio.checked = false;
          }
        });
        const matchingChildProduct = categoryElement.querySelector(`[data-child-product-id="${childOptionId}"]`);
        if (matchingChildProduct) {
          matchingChildProduct.classList.add('product__picker-product--active');
          const matchingChildProductRadio = matchingChildProduct.querySelector('input[type="radio"]');
          if (matchingChildProductRadio) {
            matchingChildProductRadio.checked = true;
          }
          closeLearnMorePopup();
        }
      }
    });
  });
});

document.querySelectorAll('[data-option-adon-select-button]').forEach((button) => {
  button.addEventListener('click', function () {
    const childOptionId = this.getAttribute('data-child-option-id');
    const learnMoreItem = this.closest('[data-learnmore-item]');
    const learnMoreCategory = learnMoreItem.getAttribute('data-learnmore-item-category');
    document.body.style.overflow = 'auto';
    document.querySelectorAll('[data-category-name]').forEach((categoryElement) => {
      if (categoryElement.getAttribute('data-category-name') === learnMoreCategory) {
        const childProductElements = categoryElement.querySelectorAll('[data-child-adon-product-id]');
        const matchingChildProduct = categoryElement.querySelector(`[data-child-adon-product-id="${childOptionId}"]`);
        if (matchingChildProduct) {
          const matchingChildProductCheckbox = matchingChildProduct.querySelector('input[type="checkbox"]');
          if (matchingChildProduct.classList.contains('product__picker-product--active') && matchingChildProductCheckbox.checked) {
            closeLearnMorePopup();
            return;
          }
          if (matchingChildProductCheckbox.checked) {
            matchingChildProduct.click();
            matchingChildProductCheckbox.checked = false;
            matchingChildProduct.classList.remove('product__picker-product--active');
          } else {
            matchingChildProduct.click();
            matchingChildProductCheckbox.checked = true;
            matchingChildProduct.classList.add('product__picker-product--active');
          }
          closeLearnMorePopup();
        }
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const popupBackground = document.querySelector('[data-overlay-popup]');
  const learnMorePopup = document.querySelector('[data-learnmore-popup]');
  const learnMorePopupSwiper = document.querySelector('.product__learn-more-popup');
  
  learnMorePopup.addEventListener('click', function(e){
    if (e.target === learnMorePopup) {
      popupBackground.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  })

  learnMorePopupSwiper.addEventListener('click', function(e){
    if (e.target === learnMorePopupSwiper) {
      popupBackground.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  })
})